// extracted by mini-css-extract-plugin
export var chip = "_mp-2";
export var chipBody = "_mp-8";
export var chipHeader = "_mp-9";
export var chipWithKind = "_mp-7";
export var icon = "_mp-3";
export var kind = "_mp-a";
export var remove = "_mp-5";
export var removeIcon = "_mp-6";
export var row = "_mp-0";
export var rowHistorical = "_mp-1";
export var text = "_mp-4";